import { useLocation } from 'react-router-dom';

export const useSearchParam = (param) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return params.get(param);
};

export const addSearchParam = (param, value) => {
  const search = window.location.search;
  const params = new URLSearchParams(search);

  // Remove param if value is empty
  if (value === null || value === undefined || value === '') {
    params.delete(param);
    return params.toString();
  }

  if (params.has(param)) {
    params.delete(param);
  }
  params.append(param, value);
  return params.toString();
};
